import { render } from "./ReleaseSupply.vue?vue&type=template&id=2b9fa6b4&scoped=true&ts=true&lang=pug"
import script from "./ReleaseSupply.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReleaseSupply.vue?vue&type=script&setup=true&lang=ts"

import "./ReleaseSupply.vue?vue&type=style&index=0&id=2b9fa6b4&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9fa6b4"]])

export default __exports__